module.exports = __webpack_public_path__ + "04d2d1fd1125806a3150f04002722d8e.svg";